import { createSlice } from '@reduxjs/toolkit';
import { RootState } from 'reducer/store';

// export interface IloadingCountState {
//   loadingCount: number;
// }

// const initialState: IloadingCountState = {
//   loadingCount: 0,
// };

const loadingMask = createSlice({
  name: 'loadingMask',
  initialState: { show: true, count: 0 },
  reducers: {
    enableMask: (state) => {
      return { ...state, show: true };
    },
    disabledMask: (state) => {
      return { ...state, show: false };
    },
    showLoading: (state) => {
      return {
        ...state,
        count: state.show ? Math.abs(state.count) + 1 : state.count,
      };
    },
    closeLoading: (state) => {
      return { ...state, count: state.show ? -1 : state.count };
    },
  },
});
// 取值 get
export const getLoadingMaskReducer = (state: RootState) =>
  state.loadingMaskReducer;
// set
export const { showLoading, closeLoading, enableMask, disabledMask } =
  loadingMask.actions;
const loadingMaskReducer = loadingMask.reducer;
export default loadingMaskReducer;
